<template>
    <div class="single-answer">
        <div class="question-title">Question {{question.questionNo}}</div>
        <div class="question-part">
            <div class="que-row">
                <div class="que-col-1">&nbsp;</div>
                <div class="que-col-2">
                    <div class="ck-editor">
                        <ckeditor :editorUrl="editorURL"  v-model="questionData" :config="{contentsCss: ['body {font-size: 16px;}'],toolbarStartupExpanded:false,startupFocus:true}"></ckeditor>
                    </div>
                </div>
            </div> 
        </div>
        <div class="question-title">Options</div>
        <div class="question-part">
            <div class="que-row">
                <div class="que-col-1"> 
                    <span class="opction-text">A</span>
                    <v-radio color="red"></v-radio>
                </div>  
                <div class="que-col-2">
                    <div class="ck-editor">
                        <ckeditor :editorUrl="editorURL"  v-model="questionData" :config="{contentsCss: ['body {font-size: 16px;}'],toolbarStartupExpanded:false,startupFocus:false}"></ckeditor>
                    </div>
                </div>
            </div>
            <div class="que-row">
                <div class="que-col-1">
                    <span class="opction-text">B</span>
                    <v-radio color="red"></v-radio>
                </div>
                <div class="que-col-2">
                    <div class="ck-editor">
                       <ckeditor :editorUrl="editorURL"  v-model="questionData" :config="{contentsCss: ['body {font-size: 16px;}'],toolbarStartupExpanded:false,startupFocus:false}"></ckeditor>
                    </div>
                </div>
            </div>
            <div class="que-row">
                <div class="que-col-1">
                    <span class="opction-text">C</span>
                    <v-radio color="red"></v-radio>
                </div>
                <div class="que-col-2">
                    <div class="ck-editor">
                        <ckeditor :editorUrl="editorURL"  v-model="questionData" :config="{contentsCss: ['body {font-size: 16px;}'],toolbarStartupExpanded:false,startupFocus:false}"></ckeditor>
                    </div>
                </div>
            </div>
            <div class="que-row">
                <div class="que-col-1">
                    <span class="opction-text">D</span>
                    <v-radio color="red"></v-radio>
                </div>
                <div class="que-col-2">
                    <div class="ck-editor">
                        <ckeditor :editorUrl="editorURL"  v-model="questionData" :config="{contentsCss: ['body {font-size: 16px;}'],toolbarStartupExpanded:false,startupFocus:false}"></ckeditor>
                    </div>
                </div>
            </div>
        </div>        

        <!-- <div class="question-title">Hint 1</div>
        <div class="ans-part">
            <div class="que-row">
                <div class="que-col-1">
                    <span class="delete-icon"><v-icon>mdi-delete-circle</v-icon></span>
                </div>
                <div class="que-col-2">
                    <div class="ck-editor">
                        <ckeditor :editorUrl="editorUrl"  v-model="questionData" :config="{contentsCss: ['body {font-size: 16px;}'],toolbarStartupExpanded:false,startupFocus:false}"></ckeditor>
                    </div>
                </div>
            </div>
        </div>
        <div class="que-row add-sl-opction">
            <div class="que-col-1">&nbsp;</div>
            <div class="que-col-2">
                <div class="add-opction">
                    <div class="circle-icon">
                        <v-icon>mdi-plus-circle</v-icon> 
                        <span>Add Hint</span>
                    </div>
                </div>
            </div>
        </div> -->


        <div class="question-title">Solution</div>
        <div class="ans-part">
            <div class="que-row">
                <div class="que-col-1">&nbsp;</div>
                <div class="que-col-2">
                    <div class="ck-editor">
                        <ckeditor :editorUrl="editorURL"  v-model="questionData" :config="{contentsCss: ['body {font-size: 16px;}'],toolbarStartupExpanded:false,startupFocus:false}"></ckeditor>
                    </div>
                </div>
            </div>
        </div>
        <div class="right-align">
            <v-btn class="right-btn cust-btn" color="primary">{{question.btnText}}</v-btn>
        </div>
    </div>
</template>
<script>
export default {
    name: 'AssertionReason',
    data() {
        return {
          questionData: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
        }
    },
 }
</script>